// Text of the catalogue page, English and Hindi (from the approved mockup).
export const GROUPS = [
  { key: "all", en: "All", hi: "सभी" },
  { key: "new", en: "New", hi: "नए" },
  { key: "earrings", en: "Earrings", hi: "ईयररिंग" },
  { key: "necklace", en: "Necklace & Sets", hi: "नेकलेस और सेट" },
  { key: "hand", en: "Rings & Bracelets", hi: "अंगूठी और ब्रेसलेट" },
  { key: "head", en: "Head & Nose", hi: "माथा और नथ" },
  { key: "more", en: "More", hi: "अन्य" },
];

export const STR = {
  en: {
    hello: (name) => (name ? `Namaste, ${name} ji` : "Namaste"),
    intro: (rep, n) => `${rep || "Jewels of Joy"} has picked ${n} wholesale catalogue${n === 1 ? "" : "s"} for you. Tap any catalogue to view it.`,
    sCat: "catalogues", sPrice: "wholesale", sUpd: "last updated",
    repRole: "Your Jewels of Joy contact",
    search: "Search catalogues", view: "View", pages: "pages", large: "Large file · use Wi-Fi", newB: "NEW",
    download: "Download",
    empty: "No catalogue matches your search.",
    orderH: "Ready to order?",
    orderP: "Send the design numbers (like JJTKK-J3730) and quantity on WhatsApp.",
    orderBtn: "Order on WhatsApp",
    footNote: "Prices are wholesale and may change. This page was shared with you by Jewels of Joy.",
    gateTitle: "Your catalogues are ready",
    gateSub: (rep, n) => `${rep ? `${rep} from Jewels of Joy` : "Jewels of Joy"} shared ${n} catalogue${n === 1 ? "" : "s"} with you.`,
    gateLabel: "Enter the mobile number this link was sent to",
    gatePlaceholder: "10-digit mobile number",
    gateBtn: "Open catalogues",
    gateNote: "Only the number this link was shared with can open it.",
    viewOnly: "View only",
    sharedWith: (m) => `Shared with ${m}`,
    pageOf: (p, n) => `${p} / ${n}`,
    pagesLoad: "Pages load as you scroll",
    endedTitle: "This link has ended",
    contactRep: (rep) => `Ask ${rep || "us"} for a new link on WhatsApp.`,
    chatRep: "WhatsApp us",
    invalidTitle: "This link is not valid",
    invalidSub: "Please check the link you received on WhatsApp.",
    loading: "Loading…",
    retry: "Try again",
    errors: {
      INVALID_NUMBER: "Enter a 10-digit mobile number.",
      NUMBER_MISMATCH: "This link was shared with a different mobile number.",
      ACCESS_ENDED: "Catalogue access for this number has ended.",
      TOO_MANY_ATTEMPTS: "Too many wrong attempts. Try again after an hour, or contact the person who sent you this link.",
      LINK_EXPIRED: "This link has expired.",
      LINK_REVOKED: "This link has been switched off.",
      NETWORK: "No internet connection. Check your network and try again.",
      DEFAULT: "Something went wrong. Please try again.",
    },
  },
  hi: {
    hello: (name) => (name ? `नमस्ते, ${name} जी` : "नमस्ते"),
    intro: (rep, n) => `${rep || "Jewels of Joy"} ने आपके लिए ${n} होलसेल कैटलॉग चुने हैं। कोई भी कैटलॉग देखने के लिए टैप करें।`,
    sCat: "कैटलॉग", sPrice: "होलसेल रेट", sUpd: "अपडेट",
    repRole: "Jewels of Joy संपर्क",
    search: "कैटलॉग खोजें", view: "देखें", pages: "पेज", large: "बड़ी फ़ाइल · Wi-Fi पर खोलें", newB: "नया",
    download: "डाउनलोड",
    empty: "आपकी खोज से कोई कैटलॉग नहीं मिला।",
    orderH: "ऑर्डर करना है?",
    orderP: "डिज़ाइन नंबर (जैसे JJTKK-J3730) और मात्रा WhatsApp पर भेजें।",
    orderBtn: "WhatsApp पर ऑर्डर करें",
    footNote: "रेट होलसेल हैं और बदल सकते हैं। यह पेज Jewels of Joy ने आपके साथ शेयर किया है।",
    gateTitle: "आपके कैटलॉग तैयार हैं",
    gateSub: (rep, n) => `${rep ? `Jewels of Joy से ${rep}` : "Jewels of Joy"} ने आपके साथ ${n} कैटलॉग शेयर किए हैं।`,
    gateLabel: "वह मोबाइल नंबर डालें जिस पर यह लिंक भेजा गया था",
    gatePlaceholder: "10 अंकों का मोबाइल नंबर",
    gateBtn: "कैटलॉग खोलें",
    gateNote: "यह लिंक सिर्फ़ उसी नंबर से खुलेगा जिसके साथ शेयर किया गया है।",
    viewOnly: "सिर्फ़ देखने के लिए",
    sharedWith: (m) => `${m} के साथ शेयर किया गया`,
    pageOf: (p, n) => `${p} / ${n}`,
    pagesLoad: "स्क्रॉल करने पर पेज खुलते जाएंगे",
    endedTitle: "यह लिंक बंद हो गया है",
    contactRep: (rep) => `नए लिंक के लिए WhatsApp पर ${rep || "हमसे"} संपर्क करें।`,
    chatRep: "WhatsApp करें",
    invalidTitle: "यह लिंक सही नहीं है",
    invalidSub: "कृपया WhatsApp पर मिला लिंक दोबारा देखें।",
    loading: "लोड हो रहा है…",
    retry: "फिर से कोशिश करें",
    errors: {
      INVALID_NUMBER: "10 अंकों का मोबाइल नंबर डालें।",
      NUMBER_MISMATCH: "यह लिंक किसी दूसरे मोबाइल नंबर के साथ शेयर किया गया है।",
      ACCESS_ENDED: "इस नंबर के लिए कैटलॉग देखने की सुविधा खत्म हो गई है।",
      TOO_MANY_ATTEMPTS: "बहुत बार गलत नंबर डाला गया। एक घंटे बाद कोशिश करें या लिंक भेजने वाले से संपर्क करें।",
      LINK_EXPIRED: "यह लिंक एक्सपायर हो गया है।",
      LINK_REVOKED: "यह लिंक बंद कर दिया गया है।",
      NETWORK: "इंटरनेट कनेक्शन नहीं है। नेटवर्क चेक करके फिर कोशिश करें।",
      DEFAULT: "कुछ गड़बड़ हुई। कृपया फिर से कोशिश करें।",
    },
  },
};

export const errorText = (lang, code) => STR[lang].errors[code] || STR[lang].errors.DEFAULT;
